// ui
import { Icon, IconProps } from "@chakra-ui/react";

export const TwitterFilledIcon = (props: IconProps) => (
  <Icon viewBox="0 0 48 48" fill="none" {...props}>
    <g clipPath="url(#clip0_198_9906)">
      <path
        d="M44.1488 11.2002C42.6316 11.869 41.0226 12.3081 39.3751 12.5033C41.1116 11.4684 42.4113 9.83984 43.0319 7.92095C41.4023 8.88731 39.6156 9.56456 37.7534 9.9309C36.5025 8.59736 34.8445 7.71295 33.0372 7.41516C31.2298 7.11738 29.3744 7.4229 27.7593 8.28423C26.1442 9.14557 24.8599 10.5145 24.1061 12.1781C23.3524 13.8417 23.1713 15.7069 23.5912 17.4836C20.2863 17.3185 17.0533 16.4628 14.1019 14.972C11.1505 13.4811 8.5468 11.3885 6.45977 8.82988C5.72103 10.0942 5.33282 11.5314 5.3349 12.9944C5.3349 15.8657 6.8016 18.4024 9.03147 19.8876C7.71185 19.8462 6.42128 19.4911 5.26733 18.8519V18.9549C5.26773 20.8672 5.93186 22.7206 7.14711 24.2007C8.36236 25.6808 10.0539 26.6967 11.9351 27.0759C10.7101 27.4067 9.42558 27.4555 8.17887 27.2185C8.70924 28.8646 9.74297 30.3041 11.1353 31.3357C12.5277 32.3672 14.2089 32.939 15.9436 32.9711C14.2195 34.3203 12.2454 35.3177 10.1342 35.9062C8.02303 36.4947 5.81611 36.6628 3.63965 36.4009C7.43896 38.8355 11.8617 40.128 16.3789 40.1238C31.668 40.1238 40.029 27.5037 40.029 16.5588C40.029 16.2024 40.019 15.842 40.0031 15.4895C41.6305 14.3175 43.0351 12.8657 44.1508 11.2022L44.1488 11.2002Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_198_9906">
        <rect width="47.6976" height="47.526" fill="white" transform="translate(0.104492)" />
      </clipPath>
    </defs>
  </Icon>
);
